module.exports = __webpack_public_path__ + "static/app-navigation-animation-b0f0ca632d4696b9683ef36246f23c00.gif";